<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-11">
          <h1 class="title green">
            {{ $translate("claim") | capitalize }}
            <span style="float: right;">
              {{ $translate("order") | capitalize }} :
              {{ this.order.primaryCode }}
            </span>
          </h1>
        </div>
        <div class="column has-text-right">
          <b-field grouped>
            <!--<b-field>
              <b-button
                type="is-primary"
                icon-right="check"
                @click="checkClaim()"
                :disabled="
              $store.getters.user.userInfo.type == 'C' &&
                $store.getters.user.userInfo.level == '1'
            "
                v-if="
              amIClaimSender(claim.AdminClaim) && claim.status == 'responseSent'
            "
              />
            </b-field>-->
            <b-field>
              <b-dropdown
                aria-role="list"
                position="is-bottom-left"
                :disabled="
                  $store.getters.user.userInfo.type == 'C' &&
                  $store.getters.user.userInfo.level == '1'
                "
              >
                <b-button
                  type="is-primary"
                  slot="trigger"
                  icon-right="menu"
                  v-if="
                    amIClaimSender(claim.AdminClaim) &&
                    claim.status == 'responseSent'
                  "
                />
                <b-dropdown-item
                  class="pointercursor linktype"
                  @click="checkClaim()"
                  >{{ $translate("close_claim") }}</b-dropdown-item
                >
                <b-dropdown-item
                  class="pointercursor linktype"
                  @click="inadequateClaim()"
                  >{{
                    $translate("close_claim_inadequate_answer")
                  }}</b-dropdown-item
                >
                <b-dropdown-item
                  class="pointercursor linktype"
                  @click="closeClaimAsInadequate()"
                  >{{
                    $translate("close_claim_inadequate_no_answer")
                  }}</b-dropdown-item
                >
              </b-dropdown>
            </b-field>
          </b-field>
        </div>
      </div>
      <div class="container">
        <div class="columns">
          <div class="column"></div>
          <div class="column">
            <p>{{ $translate("patient") | capitalize }}</p>
          </div>
          <div class="column">
            <strong>{{ patientname }}</strong>
          </div>

          <div class="column">
            <p>{{ $translate("orderType") }}</p>
          </div>
          <div class="column">
            <strong>{{ $translate(order.orderType) | capitalize }}</strong>
          </div>
          <div class="column"></div>
        </div>
        <div class="columns">
          <div class="column"></div>
          <div class="column">
            <p>{{ $translate("rif_ordine") }}</p>
          </div>
          <div class="column">
            <strong>{{ order.primaryCode }}</strong>
          </div>

          <div class="column">
            <p>{{ $translate("deliveryType") }}</p>
          </div>
          <div class="column">
            <strong>
              {{ $translate(order.deliverySelected) | capitalize }}
            </strong>
          </div>
          <div class="column"></div>
        </div>
        <div class="columns">
          <div class="column"></div>
          <div class="column">
            <p>{{ $translate("creator") }}</p>
          </div>
          <div class="column">
            <strong>{{ order.tec }}</strong>
          </div>

          <div class="column">
            <p>{{ $translate("date_in") }}</p>
          </div>
          <div class="column">
            <strong>
              {{ new Date(order.creationDate).toLocaleDateString() }}
            </strong>
          </div>
          <div class="column"></div>
        </div>

        <div class="columns">
          <div class="column"></div>
          <div class="column">
            <p>{{ $translate("claim_by") }}</p>
          </div>
          <div class="column">
            <strong>{{ claim.tec }}</strong>
          </div>

          <div class="column">
            <p>{{ $translate("date_in") }}</p>
          </div>
          <div class="column">
            <strong>
              {{ new Date(claim.creationDate).toLocaleDateString() }}
            </strong>
          </div>
          <div class="column"></div>
        </div>

        <div class="columns" v-if="claim.AdminClaim">
          <div class="column"></div>
          <div class="column">
            <p>{{ $translate("answered_by") }}</p>
          </div>
          <div class="column">
            <strong>{{ claim.answertec }}</strong>
          </div>

          <div class="column">
            <p>{{ $translate("date_in") }}</p>
          </div>
          <div class="column">
            <strong>{{
              new Date(claim.answercreationDate).toLocaleDateString()
            }}</strong>
          </div>
          <div class="column"></div>
        </div>
        <div class="columns">
          <div class="column"></div>
          <div class="column">
            <p>{{ $translate("checked_by") }}</p>
          </div>
          <div class="column">
            <strong>{{ claim.Checktec }}</strong>
          </div>

          <div class="column">
            <p>{{ $translate("date_in") }}</p>
          </div>
          <div class="column">
            <strong>{{
              new Date(claim.DateCheck).toLocaleDateString()
            }}</strong>
          </div>
          <div class="column"></div>
        </div>
      </div>

      <hr class="green" />

      <b-field
        :label="$translate('generalInfotext')"
        horizontal
        v-if="claim.generalInfo"
        >{{ claim.generalInfotext }}</b-field
      >
      <b-field
        :label="$translate('generalInfoanswer')"
        horizontal
        v-if="claim.generalInfo && claim.answer && claim.AdminClaim"
      >
        <strong>{{ claim.generalInfoanswer }}</strong>
      </b-field>

      <b-field
        :label="$translate('orderTypetext')"
        horizontal
        v-if="claim.orderType"
        >{{ claim.orderTypetext }}</b-field
      >

      <b-field
        :label="$translate('orderTypeanswer')"
        horizontal
        v-if="claim.orderType && claim.answer && claim.AdminClaim"
      >
        <strong>{{ claim.orderTypeanswer }}</strong>
      </b-field>

      <b-field :label="$translate('modeltext')" horizontal v-if="claim.model">{{
        claim.modeltext
      }}</b-field>

      <b-field
        :label="$translate('modelanswer')"
        horizontal
        v-if="claim.model && claim.answer && claim.AdminClaim"
      >
        <strong>{{ claim.modelanswer }}</strong>
      </b-field>

      <b-field
        :label="$translate('footmeasurementstext')"
        horizontal
        v-if="claim.footmeasurements"
        >{{ claim.footmeasurementstext }}</b-field
      >

      <b-field
        :label="$translate('footmeasurementsanswer')"
        horizontal
        v-if="claim.footmeasurements && claim.answer && claim.AdminClaim"
      >
        <strong>{{ claim.footmeasurementsanswer }}</strong>
      </b-field>

      <b-field
        :label="$translate('prod_detailstext')"
        horizontal
        v-if="claim.prod_details"
        >{{ claim.prod_detailstext }}</b-field
      >

      <b-field
        :label="$translate('prod_detailsanswer')"
        horizontal
        v-if="claim.prod_details && claim.answer && claim.AdminClaim"
      >
        <strong>{{ claim.prod_detailsanswer }}</strong>
      </b-field>

      <b-field
        v-if="claim.attachbool"
        :label="$translate('file') | capitalize"
        horizontal
      >
        <a target="_blank" v-bind:href="claim.attach">
          <b-button>{{ $translate("link_to_file") | capitalize }}</b-button>
        </a>
      </b-field>
      <b-field
        v-if="claim.attachboolanswer"
        :label="$translate('file_answer') | capitalize"
        horizontal
      >
        <a target="_blank" v-bind:href="claim.attachanswer">
          <b-button>{{ $translate("link_to_file") | capitalize }}</b-button>
        </a>
      </b-field>
    </div>

    <b-modal
      :active.sync="inadequateClaimModal"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      :can-cancel="true"
    >
      <div class="modal-card" :width="640" scroll="keep">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate("inadequate_claim") | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('generalInfo')" horizontal>
            <b-checkbox v-model="newclaim.generalInfo"></b-checkbox>
          </b-field>
          <b-field
            :message="errors.first('generalInfotext')"
            :type="{ 'is-danger': errors.has('generalInfotext') }"
            horizontal
            v-if="newclaim.generalInfo"
          >
            <b-input
              name="generalInfotext"
              type="textarea"
              v-model="newclaim.generalInfotext"
              v-validate="'required'"
            ></b-input>
          </b-field>
          <b-field :label="$translate('orderType')" horizontal>
            <b-checkbox v-model="newclaim.orderType"></b-checkbox>
          </b-field>
          <b-field
            :message="errors.first('orderTypetext')"
            :type="{ 'is-danger': errors.has('orderTypetext') }"
            horizontal
            v-if="newclaim.orderType"
          >
            <b-input
              name="orderTypetext"
              type="textarea"
              v-model="newclaim.orderTypetext"
              v-validate="'required'"
            ></b-input>
          </b-field>
          <b-field :label="$translate('model') | capitalize" horizontal>
            <b-checkbox v-model="newclaim.model"></b-checkbox>
          </b-field>
          <b-field
            :message="errors.first('modeltext')"
            :type="{ 'is-danger': errors.has('modeltext') }"
            horizontal
            v-if="newclaim.model"
          >
            <b-input
              name="modeltext"
              type="textarea"
              v-model="newclaim.modeltext"
              v-validate="'required'"
            ></b-input>
          </b-field>

          <b-field :label="$translate('footmeasurements')" horizontal>
            <b-checkbox v-model="newclaim.footmeasurements"></b-checkbox>
          </b-field>
          <b-field
            :message="errors.first('footmeasurementstext')"
            :type="{ 'is-danger': errors.has('footmeasurementstext') }"
            horizontal
            v-if="newclaim.footmeasurements"
          >
            <b-input
              name="footmeasurementstext"
              type="textarea"
              v-model="newclaim.footmeasurementstext"
              v-validate="'required'"
            ></b-input>
          </b-field>

          <b-field v-if="config.claimHasProdDetails" :label="$translate('prod_details')" horizontal>
            <b-checkbox v-model="newclaim.prod_details"></b-checkbox>
          </b-field>
          <b-field
            :message="errors.first('prod_detailstext')"
            :type="{ 'is-danger': errors.has('prod_detailstext') }"
            horizontal
            v-if="newclaim.prod_details"
          >
            <b-input
              name="prod_detailstext"
              type="textarea"
              v-model="newclaim.prod_detailstext"
              v-validate="'required'"
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="inadequateClaimModal = false"
          >
            {{ $translate("undo") | capitalize }}
          </button>
          <button
            type="button"
            class="button is-primary"
            @click="submitInadequateClaim()"
            :disabled="
              !newclaim.prod_details &&
              !newclaim.footmeasurements &&
              !newclaim.orderType &&
              !newclaim.generalInfo &&
              !newclaim.model
            "
          >
            {{ $translate("create_claim") | capitalize }}
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import permissionMixin from "../../helpers/mixins/permissionMixin";

export default {
  $_veeValidate: {
    validator: "new",
  },

  name: "Claim",
  mixins: [permissionMixin],
  components: {},
  data() {
    return {
      id: null,
      orderid: null,
      patientname: null,
      inadequateClaimModal: false,
      claim: {},
      newclaim: {},
      order: {},
    };
  },
  computed: {
    config() {
      return this.$moduleConfiguration[this.order.module ? this.order.module : "tailored"];
    },
  },
  methods: {
    submitInadequateClaim() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.claim.Checktec = this.$store.getters.user.userInfo.username;
          this.claim.DateCheck = new Date().getTime();
          this.claim.confirmed = true;
          this.claim.inadequate = true;
          this.claim.status = "confirmed";
          this.order.claims[this.id] = this.claim;

          this.newclaim.lastModificationDate = new Date().getTime();
          this.newclaim.status = "sent";
          this.newclaim.AdminClaim = this.ClaimType();

          this.newclaim.tec = this.$store.getters.user.userInfo.username;
          this.newclaim.creationDate = new Date().getTime();
          this.newclaim.originalStatus = this.claim.originalStatus;
          this.order.claims.push(this.newclaim);
          //let newid = this.order.claims.length;

          //this.order.haveclaimsAdmin = true;
          //this.order.haveclaimsCustomer = true;

          //Controllo che ci siano claim attivi (non confermati e non cancellati)
          this.order.haveclaimsAdmin = false;
          this.order.haveclaimsCustomer = false;
          for (let index in this.order.claims) {
            if (
              !this.order.claims[index].deleted &&
              !this.order.claims[index].confirmed
            ) {
              if (this.order.claims[index].status != "saved") {
                this.order.haveclaimsAdmin = true;
                this.order.haveclaimsCustomer = true;
              } else {
                if (this.claim.AdminClaim) {
                  this.order.haveclaimsAdmin = true;
                } else {
                  this.order.haveclaimsCustomer = true;
                }
              }
            }
          }

          await this.$db
            .collection("orders")
            .doc(this.order.id)
            .update({
              claims: this.order.claims,
              haveclaimsCustomer: this.order.haveclaimsCustomer,
              haveclaimsAdmin: this.order.haveclaimsAdmin,
            })
            .then(() => {
              this.$router.push({ name: "orders" });
            });
        }
      });
    },
    inadequateClaim() {
      this.inadequateClaimModal = true;
    },
    async closeClaimAsInadequate() {
      this.claim.inadequate = true;
      this.claim.originalStatus = "standord";
      this.checkClaim();
    },
    async checkClaim() {
      // Cambia lo stato dell'ordine e conferma (chiude) il claim
      this.claim.Checktec = this.$store.getters.user.userInfo.username;
      this.claim.DateCheck = new Date().getTime();
      this.claim.confirmed = true;
      this.claim.status = "confirmed";
      this.order.claims[this.id] = this.claim;

      this.order.haveclaimsAdmin = false;
      this.order.haveclaimsCustomer = false;
      for (let index in this.order.claims) {
        if (
          !this.order.claims[index].deleted &&
          !this.order.claims[index].confirmed
        ) {
          if (this.order.claims[index].status != "saved") {
            this.order.haveclaimsAdmin = true;
            this.order.haveclaimsCustomer = true;
          } else {
            if (this.claim.AdminClaim) {
              this.order.haveclaimsAdmin = true;
            } else {
              this.order.haveclaimsCustomer = true;
            }
          }
        }
      }

      await this.$db
        .collection("orders")
        .doc(this.orderid)
        .update({
          statusOrder: this.claim.originalStatus,
          claims: this.order.claims,
          haveclaimsAdmin: this.order.haveclaimsAdmin,
          haveclaimsCustomer: this.order.haveclaimsCustomer,
        })
        .then(() => {
          this.$router.push({ name: "orders" });
        });
    },
  },
  async created() {
    this.id = this.$route.params.id;
    this.orderid = this.$route.params.orderid;
    if (this.orderid == null) {
      this.$router.push({ name: "orders" });
    }
    if (this.id == null) {
      this.$router.push({ name: "orders" });
    }
    await this.$db
      .collection("orders")
      .doc(this.orderid)
      .get()
      .then((doc) => {
        this.order = doc.data();
        this.claim = this.order.claims[this.id];
      });

    await this.$db
      .collection("patients")
      .doc(this.order.patientId)
      .get()
      .then((patientDoc) => {
        this.order.patient = patientDoc.data();
        this.patientname =
          this.order.patient.name + " " + this.order.patient.surname;
      });
  },
};
</script>
